import {
    CategoryConfigurableAttributesComponent as SourceCategoryConfigurableAttributesComponent,
} from 'SourceComponent/CategoryConfigurableAttributes/CategoryConfigurableAttributes.component';

import './CategoryConfigurableAttributes.override.style';
import React from "react";
import AdvaceOtions from 'Component/AdvaceOtions/AdvaceOtions.component';
import { sortBySortOrder } from '@scandipwa/scandipwa/src/util/Product';
import ExpandableContentShowMore from 'Component/ExpandableContentShowMore';
import RenderWhenVisible from '@scandipwa/scandipwa/src/component/RenderWhenVisible';
import ExpandableContent from 'Component/ExpandableContent';

export class CategoryConfigurableAttributesComponent extends SourceCategoryConfigurableAttributesComponent {
    renderConfigurableAttributes() {
        const { configurable_options, updateConfigurableVariant } = this.props;

        const configurable_optionsvalue = sortBySortOrder(Object.values(configurable_options), 'attribute_position');

        const configrableoption = configurable_optionsvalue.filter((value) => {
            return value.attribute_code !== "category_uid";
        })

        return (
            <>
                {
                    configrableoption?.slice(0, 6)?.map(this.renderConfigurableOption.bind(this))
                }
            </>
        );
    }

    renderDropdown(option) {
        const { attribute_values = [] } = option;
        const { updateConfigurableVariant } = this.props;

        return (
            <div className='ProductConfigurableAttributes-DropDownList'>
                <ExpandableContentShowMore updateConfigurableVariant={updateConfigurableVariant}>
                    {
                        attribute_values.map((attribute_value) => (
                            this.renderConfigurableAttributeValue({ ...option, attribute_value })
                        ))
                    }
                </ExpandableContentShowMore>
            </div>
        );
    }

    renderDropdownOrSwatch(option) {
        const {
            isContentExpanded,
        } = this.props;

        const {
            attribute_label,
            attribute_code,
            attribute_options,
        } = option;

        const [{ swatch_data = null }] = attribute_options ? Object.values(attribute_options) : [{}];
        const isSwatch = !!swatch_data;

        return (
            <RenderWhenVisible fallback={() => <div className="ProductConfigurableAttributes-Placeholders" />}>
                <ExpandableContent
                    key={attribute_code}
                    heading={attribute_label}
                    mix={{
                        block: `${attribute_code} ProductConfigurableAttributes`,
                        elem: 'Expandable',
                    }}
                    isContentExpanded={false}
                    isArrow={true}
                >
                    {isSwatch ? this.renderSwatch(option) : this.renderSwatch(option)}
                </ExpandableContent>
            </RenderWhenVisible>
        );
    }
}

export default CategoryConfigurableAttributesComponent;
